// extracted by mini-css-extract-plugin
export default {"term__button":"term_term__button__jPcGu","term__container":"term_term__container__4NPHk","list__term":"term_list__term__N2UfV"};